<template>
  <div>
    <b-form ref="secretValueForm" @submit.prevent="onChange">
      <b-form-input
          id="secret-input-validate-live"
          v-model="newSecret"
          :state="checkSecretState"
          aria-describedby="secret-input-validate-live-help secret-input-validate-live-feedback"
          :placeholder="$t('secretChange.placeHolderText')"
          class="mb-2 mr-sm-2 mb-sm-0"
          trim
      ></b-form-input>
      <b-form-invalid-feedback id="secret-input-validate-live-feedback">{{ $t("unitSecret.invalid") }}{{this.$store.getters.getPassphraseMinLength}}-63</b-form-invalid-feedback>
      <b-form-text id="secret-input-validate-live-help">{{ $t("unitSecret.formText")}}</b-form-text>
      <b-button :disabled="!checkSecretState" type="submit" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
      <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
    </b-form>

  </div>
</template>

<script>
export default {
  name: "SecretInputBox",
  data() {
    return {
      newSecret: ''
    }
  },
  computed: {
    checkSecretState() {
      //check size and for no white spaces
      return ( (this.newSecret.length >= this.$store.getters.getPassphraseMinLength  && this.newSecret.length <=63))? true : false
    }
  },
  methods:{
    onChange(evt){
      evt.preventDefault()
      if((this.newSecret.length >= this.$store.getters.getPassphraseMinLength  && this.newSecret.length <=63)){
        this.$emit('changeSecret', [this.newSecret, true])
      }else{
        this.$emit('changeSecret', [this.newSecret, false])
      }
    },
    onCancel(){
      this.$emit('cancelSecretChange')
    },
  }
}
</script>

<style scoped>

</style>